export const ttlockConfig = {
  credentials: {
    title: "TTLock-Konfiguration",
    subtitle: "Geben Sie die Zugangsdaten Ihres TTLock-Kontos ein",
    savedBadge: "Zugangsdaten gespeichert",
    noneBadge: "Keine Zugangsdaten",
    emailLabel: "E-Mail Ihres TTLock-Kontos",
    emailPlaceholder: "you@example.com",
    emailHelp: "Die E-Mail-Adresse, mit der Sie sich bei TTLock anmelden",
    passwordLabel: "Passwort",
    passwordPlaceholderSaved: "•••••••• (gespeichert, Änderung optional)",
    passwordPlaceholder: "Ihr TTLock-Passwort",
    passwordHelpSaved: "Sie können es leer lassen, wenn bereits eines gespeichert ist.",
    passwordHelp: "Das Passwort Ihres TTLock-Kontos.",
    testing: "Wird getestet...",
    testConnection: "Verbindung testen",
    saving: "Wird gespeichert...",
    saveCredentials: "Zugangsdaten speichern",
  },
  selector: {
    title: "Schlossauswahl für diese Unterkunft",
    subtitleBefore: "Wählen Sie nur die Schlösser aus, die zu ",
    subtitleStrong: "dieser Unterkunft",
    subtitleAfter: " gehören.",
    selectedCount: "{count} ausgewählt | {count} ausgewählt",
    hintBefore: "Geben Sie Ihre Zugangsdaten ein und klicken Sie auf ",
    hintStrong: "Verbindung testen",
    hintAfter: ", um Ihre Schlösser zu laden.",
    noneFound: "Keine Schlösser gefunden. Prüfen Sie Ihr TTLock-Konto.",
    placeholder: "Schlösser auswählen…",
    summaryCount: "{count} Schloss ausgewählt | {count} Schlösser ausgewählt",
    emptySelection: "Keine Schlösser ausgewählt",
    saving: "Wird gespeichert...",
    save: "Schlösser für diese Unterkunft speichern",
  },
  gateway: {
    with: "Mit Gateway",
    without: "Ohne Gateway",
  },
  pms: {
    title: "Steuerung und Zuordnung (PMS)",
    subtitleP1: "Ordnen Sie jedes Schloss ",
    subtitleStrongMain: "Haupteingang",
    subtitleP2: " oder ",
    subtitleStrongUnit: "Einheit",
    subtitleP3: " zu.",
    assignedCount: "{count} zugeordnet | {count} zugeordnet",
    empty: "Für diese Unterkunft sind noch keine Schlösser gespeichert.",
    assignmentLabel: "Zuordnung",
    assignmentNone: "Nicht zugeordnet",
    assignmentCommon: "Haupteingang (gemeinsam)",
    assignmentUnit: "Wohnungstür",
    hintNone: "Es wird nicht über das PMS gesteuert.",
    hintAssigned: "Es wird für Steuerung/PINs mit dieser Unterkunft verknüpft.",
    unitLabel: "Einheit / Unterkunft",
    unitSelectPlaceholder: "Einheit auswählen",
    unitHint: "Wählen Sie, welche Einheit dieses Schloss öffnet.",
    nameLabel: "Name (optional)",
    namePlaceholder: "z. B. Haupteingang / Whg. 101",
    saving: "Wird gespeichert...",
    save: "Zuordnung speichern",
  },
  actions: {
    lock: "Abschließen",
    unlock: "Öffnen",
    requiresGateway: "Gateway erforderlich",
    createPasscode: "Code erstellen",
    passcodeHistory: "Code-Verlauf",
    refreshStatus: "Status aktualisieren",
  },
  lockFallbackName: "Schloss {id}",
  unitFallbackName: "Einheit {id}",
  history: {
    title: "Code-Verlauf",
    revocationTitle: "Zum Widerrufen von Codes:",
    withGatewayLabel: "Mit Gateway:",
    withGatewayText: "Der Code wird sofort am physischen Schloss widerrufen.",
    withoutGatewayLabel: "Ohne Gateway:",
    withoutGatewayText:
      "Der Code wird vom TTLock-Server entfernt, funktioniert am Schloss aber weiter, bis sich jemand per Bluetooth über die mobile App verbindet und synchronisiert.",
    loading: "Verlauf wird geladen…",
    empty: "Für dieses Schloss sind keine Codes erfasst.",
    colAlias: "Alias",
    colPasscode: "Code",
    colValidity: "Gültigkeit",
    colStatus: "Status",
    createdAt: "Erstellt: {date}",
    fromLabel: "Von:",
    toLabel: "Bis:",
    revokedTitle: "Bereits widerrufen",
    revokeTitle: "Code löschen / widerrufen",
    close: "Schließen",
  },
  passcodeModal: {
    title: "Temporären Code erstellen",
    nameLabel: "Name / Bezeichnung",
    namePlaceholder: "z. B. Reinigung / Gast / Techniker",
    nameHint: "Dieser Name hilft Ihnen, den Code zu identifizieren.",
    validFrom: "Gültig ab",
    validTo: "Gültig bis",
    importantLabel: "Wichtig:",
    importantText:
      "Der Code wird automatisch von TTLock erzeugt und ist nur im angegebenen Zeitraum verfügbar. Der Gast kann diesen Code direkt am Tastenfeld des Schlosses eingeben (funktioniert ohne Internet).",
    noGatewayLabel: "Kein Gateway:",
    noGatewayText:
      "An diesem Schloss ist kein Gateway angeschlossen. Die erzeugten Codes funktionieren am physischen Tastenfeld einwandfrei, Sie können sie aber nicht aus der Ferne über dieses Panel widerrufen. Zum Widerrufen müssen Sie die TTLock-App nutzen und sich per Bluetooth verbinden.",
    cancel: "Abbrechen",
    creating: "Wird erstellt...",
    create: "Code erstellen",
  },
  states: {
    active: "Aktiv",
    upcoming: "Bevorstehend",
    expired: "Abgelaufen",
    revoked: "Widerrufen",
    noDate: "Kein Datum",
  },
  confirm: {
    revoke:
      'Möchten Sie den Code "{alias}" wirklich widerrufen/löschen?\n\nHinweis: Wenn das Schloss kein Gateway hat, kann der Widerruf nur teilweise erfolgen.',
  },
  toast: {
    noLocksFound: "Keine Schlösser in TTLock gefunden.",
    loadStatusError: "Der Schlossstatus konnte nicht geladen werden",
    loadStatusErrorGeneric: "Fehler beim Laden des Schlossstatus",
    credentialsRequired: "Sie müssen Benutzername und Passwort eingeben oder gespeicherte Zugangsdaten haben.",
    connectionOk:
      "Verbindung erfolgreich. {count} Gerät gefunden. | Verbindung erfolgreich. {count} Geräte gefunden.",
    testError: "Fehler beim Testen der Verbindung",
    credentialsSaved: "Zugangsdaten erfolgreich gespeichert",
    saveCredentialsError: "Fehler beim Speichern der Zugangsdaten",
    saveCredentialsErrorDetail: "Fehler beim Speichern der Zugangsdaten: {msg}",
    selectAtLeastOne: "Sie müssen mindestens ein Gerät für diese Unterkunft auswählen.",
    devicesSaved: "Geräte für diese Unterkunft gespeichert",
    devicesSaveError: "Die Geräte konnten nicht gespeichert werden",
    saveErrorDetail: "Fehler beim Speichern: {msg}",
    unitRequired: "Wählen Sie die Einheit für die als 'Wohnungstür' zugeordneten Schlösser.",
    bindingsSaved: "Zuordnung erfolgreich gespeichert",
    bindingsSaveError: "Die Zuordnung konnte nicht gespeichert werden",
    bindingsSaveErrorDetail: "Fehler beim Speichern der Zuordnung: {msg}",
    assignFirst: "Ordnen Sie das Schloss zuerst zu (Haupteingang oder Einheit) und speichern Sie, um die Steuerung zu aktivieren.",
    passcodeNameRequired: "Sie müssen einen Namen bzw. eine Bezeichnung für den Code angeben.",
    passcodeDatesRequired: "Sie müssen ein Gültig-ab- und ein Gültig-bis-Datum angeben.",
    passcodeCreated: "Code erstellt: {code}",
    passcodeCreateError: "Der Code konnte nicht erstellt werden",
    passcodeCreateErrorGeneric: "Fehler beim Erstellen des Codes",
    lockLocked: "Schloss abgeschlossen",
    lockLockError: "Abschließen nicht möglich",
    lockLockErrorGeneric: "Fehler beim Abschließen",
    lockUnlocked: "Schloss geöffnet",
    lockUnlockError: "Öffnen nicht möglich",
    lockUnlockErrorGeneric: "Fehler beim Öffnen",
    revokeNoProviderId: "Dieser Code hat keine provider_passcode_id. Er kann in TTLock nicht widerrufen werden.",
    revokedOk: "Code vollständig widerrufen",
    revokeError: "Widerruf nicht möglich",
    revokeErrorGeneric: "Fehler beim Widerrufen des Codes",
    historyLoadError: "Der Verlauf konnte nicht geladen werden",
    historyLoadErrorGeneric: "Fehler beim Laden des Verlaufs",
  },
};
